import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../utils/withPayloadType';
import { monitorDetails } from '../reducer/monitorDetails';

const initialize = createAction('monitorDetails/initialize', withPayloadType<string>());

const monitorDetailsActions = { ...monitorDetails.actions, initialize };

export default monitorDetailsActions;
